import produce from "immer";
import { AnyAction } from "redux";
import { AVAILABLE_LANGUAGES, getEnvVariable } from "utils/environment";

import { preferencesConstants } from "./constants";

import { InitialPreferencesType } from "./types/index";

const availableLanguages = getEnvVariable(AVAILABLE_LANGUAGES).split(",");

const INITIALSTATE: InitialPreferencesType = {
    region: {
        language: availableLanguages[0] || "en",
    },
    timeDateFormat: {
        dateFormat: "MM/DD/YYYY",
        timeFormat: "h:mm A",
        weekStartDay: "1",
    },
};

const PreferencesReducer = (
    state: InitialPreferencesType = INITIALSTATE,
    action: AnyAction
) =>
    produce(state, (draft) => {
        switch (action.type) {
            case preferencesConstants.SET_LANGUAGE: {
                if (availableLanguages.includes(action.payload)) {
                    draft.region.language = action.payload;
                } else draft.region.language = availableLanguages[0] || "en";

                break;
            }
            case preferencesConstants.SET_DATE:
                draft.timeDateFormat.dateFormat = action.payload;
                break;
            case preferencesConstants.SET_TIME:
                draft.timeDateFormat.timeFormat = action.payload;
                break;
            case preferencesConstants.SET_WEEK_START_DAY:
                draft.timeDateFormat.weekStartDay = action.payload;
                break;
            case preferencesConstants.SET_PREFERENCES:
                if (
                    availableLanguages.includes(action.payload.region.language)
                ) {
                    draft.region.language = action.payload.region.language;
                } else draft.region.language = availableLanguages[0] || "en";

                draft.timeDateFormat.dateFormat =
                    action.payload.timeDateFormat.dateFormat;
                draft.timeDateFormat.timeFormat =
                    action.payload.timeDateFormat.timeFormat;
                draft.timeDateFormat.weekStartDay =
                    action.payload.timeDateFormat.weekStartDay;
                break;
        }
    });

export default PreferencesReducer;
